<template>
  <div class="flex-folders">
    <div class="flex-table d-flex flex-column">
      <div v-if="loading" class="text-center text-success my-2">
          <b-spinner class="align-middle mr-2" />
          <strong>Loading...</strong>
      </div>
      <div v-for="report in reports" class="flex-table-survey">
        <div class="d-flex justify-content-between cursor-pointer">
          <div class="flex-table-survey-info"  @click.prevent="report_download(report.id)">
            <div class="d-flex justify-content-start flex-table-row align-items-center">
              <i class="fa fa-regular fa-file-chart-column"></i>
              <div class="flex-table-title">
                <span :class="`${anon ? 'g-anon' : ''}`">{{ report.survey_type }}: {{ report.report_name }}</span>
              </div>
              <div class="d-flex pl-start justify-content-start flex-table-row align-items-center">
                <div>{{ format_date(report.report_date) }}</div>
                <div>Norm: {{ normvalues_country_name(report.normvalues_id) }}</div>
                <div><lang-flag :iso="flag_code(report.language_id)" :squared="false" />{{ report.language_id }}</div>
              </div>
            </div>
          </div>
          <div class="ellipsis-button d-flex align-items-center">
            <b-dropdown right>
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <b-dropdown-item @click.prevent="report_download_file(report.id)">Download</b-dropdown-item>
              <b-dropdown-item @click.prevent="record_delete_confirm(report.id)">
                Delete
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="deleteshow" hide-footer title="Delete record?">
      Do you really want to delete this report?
      <b-button class="mt-3" variant="danger" block @click="record_delete">
        Yes, delete
      </b-button>
      <b-button class="mt-2" variant="secondary" block @click="record_delete_cancel">
        Cancel
      </b-button>
    </b-modal>

    <div class="total-show" v-if="!loading">
      <span>Showing {{ retrieved }} of {{ rows }} reports</span><a class="ml-3" href="/reports">Show all</a>
    </div>
  </div>
</template>
<script>

import LangFlag from 'vue-lang-code-flags'
import { config } from '../../../config'

const fields = [
  { key: 'id', label: 'ID', sortable: true },
  { key: 'report_name', label: 'Report name', sortable: true },
  { key: 'report_date', label: 'Date', sortable: true },
  { key: 'survey_type', label: 'Survey type', sortable: true },
  { key: 'download', tdClass: 'w-5', label: '', sortable: false },
  { key: 'action', tdClass: 'w-5', label: '', sortable: false }
]

export default {
  components: {
    LangFlag
  },
  name: 'MyAggregatedReports',
  data: function () {
    return {
      reports: [],
      fields: fields,
      visible: this.$store.state.mypage_reports_open,
      deleteshow: false,
      currentPage: 1,
      perPage: 10,
      retrieved: 0,
      languages: [],
      loading: true,
      rows: 0,
      orderby: 'report_date',
      orderdesc: true,
      normvalues_countries: this.$store.state.normvalues_countries
    }
  },
  computed: {
    anon: function () {
      return this.$store.state.anon
    }
  },
  async created () {
    await this.normvalues_countries_get()
    await this.languages_get()
    await this.reports_get()
  },
  methods: {
    async languages_get () {
      await this.$store.dispatch('languages_fetch')
        .then((resp) => {
          this.languages = resp.data.result.map(l => {
            return {
              value: l.id,
              text: l.language_name,
              code: l.language_code
            }
          })
        })
    },
    format_date (date) {
      return date.toString().replaceAll('-', '').substring(0, 8)
      var d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()
      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day
      return [year, month, day].join('')
    },
    flag_code: function (name) {
      var flag_code = ''
      for (var i = 0; i < this.languages.length; i++) {
        if (this.languages[i].text == name) {
          flag_code = this.languages[i].code
          break
        }
      }
      return flag_code
    },
    normvalues_country_name: function (norm_id) {
      var normvalues_country_name = ''
      for (var i = 0; i < this.normvalues_countries.length; i++) {
        if (this.normvalues_countries[i].country_id == norm_id) {
          normvalues_country_name = this.normvalues_countries[i].country_name
        }
      }
      return normvalues_country_name
    },
    normvalues_countries_get: async function () {
      let survey_type_id = 1
      await this.$store.dispatch('normvalues_countries_fetch')
        .then((resp) => {
          var options = []
          options.push({ value: 0, text: 'Please select norm values' })
          for (var i = 0; i < resp.data.length; i++) {
            if (resp.data[i].country_id == 999 || survey_type_id == 1) {
              var option = {
                value: resp.data[i].country_id,
                text: resp.data[i].country_name
              }
              options.push(option)
            }
          }
          this.norm_values_options = options
        })
    },
    data_sort (context) {
      this.orderby = context.sortBy
      this.orderdesc = context.sortDesc
      this.currentPage = 1
      this.reports_get()
    },
    setvisible: function () {
      this.visible = !this.visible
      this.$store.dispatch('setagreportsopen', this.visible)
    },
    record_delete_confirm (id) {
      this.deleting = id
      this.deleteshow = true
    },
    record_delete () {
      this.$store.dispatch('record_delete', {
        table_name: 'g_agreports',
        id: this.deleting
      })
        .then(() => {
          this.deleting = 0
          this.deleteshow = false
          this.reports_get()
        })
    },
    record_delete_cancel () {
      this.deleting = 0
      this.deleteshow = false
    },
    reports_get: async function () {
      this.loading = true
      await this.$store
        .dispatch('aggregatedreports_get', {
          user_id: this.$store.state.user_id,
          start: (this.currentPage - 1) * this.perPage,
          limit: this.perPage,
          orderby: this.orderby,
          order: (this.orderdesc ? 'DESC' : 'ASC')
        })
        .then(result => {
          let reports = result.data.result
          this.retrieved = result.data.result.length
          this.rows = result.data.total
          // console.log({ languages: this.languages })
          this.reports = reports.map(r => {
            return {
              id: r.id,
              report_name: r.report_name,
              report_date: r.report_date,
              survey_type: r.survey_type,
              language_id: this.languages.filter(l => l.value.toString() == r.language_id.toString())[0].text,
              normvalues_id: r.normvalues_id
            }
          })
          this.loading = false
        })
    },
    report_download_file (report_id) {
      var reporturl = config.report_url + '/gdq_agreport.php?r=' + report_id
      var downloadURL = new URL(reporturl)
      var downloadLink = document.createElement('a')
      downloadLink.href = downloadURL
      downloadLink.setAttribute('download', 'GDQ_AGReport_' + new Date().toISOString().split('T')[0])
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    report_download (id, index, event) {
      this.$store.dispatch('setcurrentaggregatedreport_id', { report_id: id })
        .then(() => {
          this.$router.push('/aggregatedreports')
        })
    }
  }
}
</script>
<style scoped></style>
